import React from 'react'
import { Route, Navigate } from 'react-router-dom';
import '../modules/register/FormInputs/Generated_Forms/Generated_Forms.css';
import LeaveRegister from '../modules/register/FormInputs/LeaveRegister/LeaveRegister';
import AttendanceRegister from '../modules/register/FormInputs/AttendanceRegister/AttendanceRegister';
import AttendanceReport from '../modules/register/FormInputs/AttendanceRegister/AttendanceReport/AttendanceReport';
import AttendanceOverride from '../modules/register/FormInputs/AttendanceOverride/AttendanceOverride';
import MaternityBenefits from '../modules/register/FormInputs/MaternityBenefits/MaternityBenefits';
import SalaryAdvances from '../modules/register/FormInputs/SalaryAdvances/SalaryAdvances';
import OtherInputs from '../modules/register/FormInputs/OtherInputs/OtherInputs'
import TN_Form_VI from '../modules/register/FormInputs/Tn_form_VI/Tn_form_VI';
import EmployeeSeparation from '../modules/register/FormInputs/Emp_Separation/Emp_Separation'
import Leaveopeningbalance from '../modules/register/FormInputs/Leaveopenbalances/Leaveopeningbalance'
import ReportViews from '../modules/register/Report/ReportViews/ReportViews'
import EmployeeMaster from '../modules/register/FormInputs/EmployeeMaster/EmployeeMaster';
import SalaryRegister from '../modules/register/FormInputs/SalaryRegister/SalaryRegister';
// import GenerateForm from '../modules/register/FormInputs/EmployeeGenerateForm'
import GenerateForm from '../modules/register/FormInputs/generateForms/EmployeeGenerateForm';
import CtcMaster from '../modules/register/FormInputs/CtcMaster/CtcMaster';
import CreateLeaves from '../modules/register/settings/Leaves/CreateLeaves/CreateLeaves';
import Report from '../modules/register/Report/Reports';
import UploadForm from '../modules/register/FormInputs/UploadForm';
import GeneratedForm from '../modules/register/FormInputs/Generated_Forms/Generated_Forms';
import Contractor from '../modules/register/FormInputs/Contractor/Contractor';
import ReturnGenerateForm from '../modules/register/FormInputs/ReturnGenerateForm/ReturnGenerateForm';
import SnECertificate from '../modules/register/FormInputs/SnECertificate/SnECertificate';
import CertificateTypes from '../modules/register/FormInputs/SnECertificate/CertificateTypes';
import RemediesComingSoon from '../modules/register/FormInputs/SnECertificate/RemediesComingSoon';
import GeneratedFormList from '../modules/register/FormInputs/Generated_Forms/Generated_Forms_List';
import ComplianceDocuments from '../modules/register/FormInputs/ComplianceDocuments/ComplianceDocuments';
import ClientUserGuide from '../modules/global/userGuide/ClientUserGuide';

function isClientUser() {
  try {
    return JSON.parse(sessionStorage.getItem("user") || "{}")?.base_role === "Client";
  } catch {
    return false;
  }
}

function CertificatePage(props) {
  if (isClientUser()) return <RemediesComingSoon {...props} />;
  return <SnECertificate {...props} />;
}

function CertificateTypesPage(props) {
  if (isClientUser()) return <RemediesComingSoon {...props} />;
  return <CertificateTypes {...props} />;
}

export function Register_routes({ showSnackbar, setLoading ,permissionMap}) {
  return (
    <>
 
      {permissionMap["InputMatrix"] && (
          <Route path="/input-matrix/" element={<UploadForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"] && (
      <Route path="/input-matrix/:date" element={<UploadForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Employee Master") && (
      <Route path="/input-matrix/employee-master/:date" element={<EmployeeMaster showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("CTC Master") && (
      <Route path="/input-matrix/ctc-master/:date" element={<CtcMaster showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Salary Register") && (
      <Route path="/input-matrix/salary-register/:date" element={<SalaryRegister showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Leave Register") && (
      <Route path="/input-matrix/leave-register/:date" element={<LeaveRegister showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Attendance Register Override") && (
      <Route path="/input-matrix/attendance-override/:date" element={<AttendanceOverride showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Maternity Benefits") && (
      <Route path="/input-matrix/maternity-benefits/:date" element={<MaternityBenefits showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Salary Advance") && (
      <Route path="/input-matrix/salary-advances/:date" element={<SalaryAdvances showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Other Inputs") && (
      <Route path="/input-matrix/other-inputs/:date" element={<OtherInputs showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Attendance Register") && (
      <Route path="/input-matrix/attendance-master/attendance-report/:date" element={<AttendanceReport showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Tamil Nadu Form VI") && (
      <Route path="/input-matrix/tamil-nadu-form-vi/:date" element={<TN_Form_VI showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {/* {permissionMap["Generated Form"] && ( */}
      <Route path="/generated-form" element={<GeneratedForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
      <Route path="/generated-form/list" element={<GeneratedFormList showSnackbar={showSnackbar} setLoading={setLoading} />} />
      <Route path="/returns" element={<ReturnGenerateForm showSnackbar={showSnackbar} setLoading={setLoading} />}/>
      <Route path="/compliance-documents"  element={<ComplianceDocuments showSnackbar={showSnackbar} setLoading={setLoading} />}/>
      <Route path="/user-guide" element={<ClientUserGuide />}/>
      <Route path="/certificate" element={<CertificatePage showSnackbar={showSnackbar} setLoading={setLoading} />}/>
      <Route path="/certificate/:certType" element={<CertificatePage showSnackbar={showSnackbar} setLoading={setLoading} />}/>
      <Route path="/certificate-types" element={<CertificateTypesPage showSnackbar={showSnackbar} setLoading={setLoading} />}/>
      <Route path="/se-certificate" element={<Navigate to="/certificate" replace />} />
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Generate Form") && (
      <Route path="/input-matrix/generate_form/:date" element={<GenerateForm showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Generate Attendance Register") && (
      <Route path="/input-matrix/attendance-master/:date" element={<AttendanceRegister showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Employee Separation") && (
      <Route path="/input-matrix/get-emp-separation/:date" element={<EmployeeSeparation showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Leave Opening Balance") && (
      <Route path="/input-matrix/leave-opening-balance/:date" element={<Leaveopeningbalance showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      {permissionMap["InputMatrix"]?.["InputMatrix"]?.includes("Staffing Agencies") && (
      <Route path="/input-matrix/staffing-agencies/:date" element={<Contractor showSnackbar={showSnackbar} setLoading={setLoading} />} />
      )}
      <Route path="/report" element={<Report showSnackbar={showSnackbar} setLoading={setLoading} />} />
      <Route path="/report/" element={<Report showSnackbar={showSnackbar} setLoading={setLoading} />} />
      <Route path="/report/:date" element={<Report showSnackbar={showSnackbar} setLoading={setLoading} />} />

      {/* {permissionMap["Configuration"]?.["Leave Ops"]?.includes("Leave Type Configuration") && ( */}
          <Route path="/configuration/leave-type-configuration" element={<CreateLeaves showSnackbar={showSnackbar} setLoading={setLoading} />} />
      {/* )} */}


      <Route path="/reports/report/:reportTitle/:date" element={<ReportViews showSnackbar={showSnackbar} setLoading={setLoading} />} />
      <Route path="/reports/report/:reportTitle/:date/:date1" element={<ReportViews showSnackbar={showSnackbar} setLoading={setLoading} />} />
    </>
  )
}